// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30VzV","type":"styles_type__1ZWbq","choices":"styles_choices__vcmPT"};